<template>
    <div class="card-container">
        <common-top-form
            selectShowPower="/coupongroupmanage/select"
            :model="formModel"
            :submitService="submitService"
            :submitData="submitData"
            @success="onSuccess"
            @openAddDialog="openAddDialog(1)"
            :show="true"
            addShowPower="/coupongroupmanage/add"
        >
        </common-top-form>
        <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
            <el-table-column
                prop="groupName"
                label="名称"
                min-width="120"
                :formatter="formatterTableData"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="valid"
                label="有效期(天)"
                min-width="120"
                :formatter="formatterTableData"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="chnCode"
                label="通道名称"
                min-width="120"
                :formatter="formatterTableDataChnCode"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                v-if="
          hasPerm('/coupongroupmanage/update') ||
          hasPerm('/coupongroupmanage/del') ||
          hasPerm('/coupongroupmanage/fafang')
        "
                label="操作"
                min-width="260"
                fixed="right"
            >
                <template slot-scope="scope">
                    <el-button
                        type="text"
                        v-if="hasPerm('/coupongroupmanage/update')"
                        @click="openAddDialog(1, scope.row)"
                    >修改
                    </el-button>
                    <el-button
                        type="text"
                        v-if="hasPerm('/coupongroupmanage/fafang')"
                        @click="openAddDialog(2, scope.row)"
                    >发放
                    </el-button>
                    <el-button
                        type="text"
                        v-if="hasPerm('/coupongroupmanage/del')"
                        @click="handleDelete(scope.row)"
                    >删除
                    </el-button>
                </template>
            </el-table-column>
        </common-table>
        <form-dialog
            ref="formDialog"
            :formDialogTitle="flag == 2 ? '发放' : itemId ? '修改' : '添加'"
            :model="dialogModel"
            :submitData="dialogData"
            :rules="dialogRules"
            :dialogService="dialogService"
            @close="dialogClose"
            @success="dialogSuccess"
            class="note"
            labelWidth="120px"
            dialogWidth="1000px"
        >
            <div v-if="flag == 1">
                <div style="display: flex">
                    <el-form-item label-width="51px" label="名称" prop="groupName">
                        <el-input
                            type="text"
                            maxlength="100"
                            v-model="dialogModel.groupName"
                            placeholder="请输入"
                            style="width: 180px"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="有效期(天)" prop="valid">
                        <el-input-number
                            v-model="dialogModel.valid"
                            :min="1"
                            :max="999999999"
                            :step="0"
                            :precision="0"
                            :controls="false"
                            placeholder="请输入"
                        ></el-input-number>
                    </el-form-item>
                    <el-form-item label="通道名称" prop="chnCode">
                        <el-select multiple collapse-tags v-model="dialogModel.chnCode">
                            <el-option
                                v-for="item in chnName"
                                :key="item.dictKey"
                                :label="item.dictValue"
                                :value="item.dictKey"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                </div>
                <div>
                    <el-button
                        type="primary"
                        size="small"
                        @click="AddLevelItem"
                        style="margin-bottom: 20px"
                    >添加
                    </el-button>
                    <div
                        class="flex-row vertical-center"
                        v-for="(item, index) in dialogModel.couponStr"
                        :key="index"
                    >
                        <div style="display: flex">
                            <el-form-item
                                label="名称(优惠券)"
                                label-width="113px"
                                :prop="'couponStr.' + index + '.couponId'"
                                :rules="couponId"
                            >
                                <el-select
                                    clearable
                                    v-model="item.couponId"
                                    placeholder="请选择"
                                    style="width: 300px"
                                >
                                    <el-option
                                        v-for="item in couponListall"
                                        :key="item.id"
                                        :label="
                      item.couponName + '（面值' + item.couponAmt + '元' + '）'
                    "
                                        :value="item.id"
                                        style="width: 300px"
                                    >
                                        <span>{{ item.couponName }}</span>
                                        <span style="color: #e6a23c"
                                        >（面值{{ item.couponAmt }}元）</span
                                        >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item
                                label="数量(张)"
                                :prop="'couponStr.' + index + '.couponNum'"
                                label-width="79px"
                                :rules="couponNum"
                            >
                                <el-input-number
                                    v-model="item.couponNum"
                                    :min="1"
                                    :max="999999999"
                                    :step="0"
                                    :precision="0"
                                    :controls="false"
                                    placeholder="请输入"
                                ></el-input-number>
                            </el-form-item>
                            <el-button
                                @click.prevent="RemoveLevelItem(item)"
                                style="margin-bottom: 20px"
                                v-if="dialogModel.couponStr.length > 1"
                            >
                                删除
                            </el-button>
                        </div>
                    </div>
                </div>
            </div>
            <div style="display: flex" v-if="flag == 2">
                <!--<el-form-item label="终端类型" prop="acctType">-->
                    <!--<el-select clearable v-model="dialogModel.acctType">-->
                        <!--<el-option-->
                            <!--v-for="item in acctTypes"-->
                            <!--:key="item.dictKey"-->
                            <!--:label="item.dictValue"-->
                            <!--:value="item.dictKey"-->
                        <!--&gt;-->
                        <!--</el-option>-->
                    <!--</el-select>-->
                <!--</el-form-item>-->
                <div style="display: flex; flex-flow: wrap; " v-show="dialogModel.acctType">
                    <el-form-item label="积分商城ID" prop="merNo">
                        <el-input
                            type="text"
                            maxlength="100"
                            v-model="dialogModel.merNo"
                            placeholder="请输入"
                            style="width: 180px"
                        ></el-input>
                    </el-form-item>
                    <div class="flex-row vertical-center mem-name">
                        <p>名称：</p>
                        <p>
                            {{dialogModel.acctType == 7 ? memName.nickName : memName.merName }}
                        </p>
                    </div>
                    <el-form-item label="批次数" prop="number">
                        <el-input
                            type="text"
                            maxlength="100"
                            v-model="dialogModel.number"
                            placeholder="请输入"
                            style="width: 180px"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="天狮ID" prop="tsId">
                        <el-input
                            type="text"
                            maxlength="100"
                            v-model="dialogModel.tsId"
                            placeholder="请输入"
                            style="width: 180px"
                        ></el-input>
                    </el-form-item>
                </div>
            </div>
        </form-dialog>
    </div>
</template>

<script>
    import CommonTopForm from "components/common/CommonTopForm";
    import CommonTable from "components/common/CommonTable";
    import CGList from "@/view/page/AppManager/CGList";
    import FormDialog from "../../dialog/FormDialog";

    import TransactionService from "service/TransactionService";

    import {encrypt, urlEncode, objKeySort} from "common/js/common-utils";
    import {loadMixin, dialogMixin, validatorsMixin} from "mixin";
    import {mapGetters} from "vuex";

    export default {
        name: "coupongroupmanage",
        components: {
            CommonTopForm,
            CommonTable,
            FormDialog,

            CGList,
        },
        data() {
            return {
                acctTypes: [{
                    dictKey: "7",
                    dictValue: "个人版",
                },
                {
                    dictKey: "9",
                    dictValue: "商户端",
                }],
                show: false,
                couponListall: [],
                memName: {},
                formModel: {},
                tableData: [],
                chnName: [],
                submitService: TransactionService.coupongroupmanageList,
                itemId: "",
                dialogModel: {
                    tsId: "",
                    number: "",
                    acctType: "7",
                    groupName: "",
                    valid: undefined,
                    chnCode: [],
                    couponStr: [
                        {
                            couponId: "",
                            couponNum: undefined,
                        },
                    ],

                    merNo: "",
                },
                dialogRules: {
                    number: [
                        {
                            required: true,
                            message: "请输入",
                        },
                    ],
                    acctType: [
                        {
                            required: true,
                            message: "请选择",
                        },
                    ],
                    groupName: [
                        {
                            required: true,
                            message: "请输入",
                        },
                    ],
                    valid: [
                        {
                            required: true,
                            message: "请输入",
                        },
                    ],
                    chnCode: [
                        {
                            required: true,
                            message: "请选择",
                        },
                    ],

                    merNo: [
                        {
                            required: true,
                            validator: (rule, value, callback) => {
                                if (!value) {
                                    callback(new Error("请输入"));
                                } else if (!/^[A-Za-z0-9]+$/.test(value)) {
                                    callback(new Error("请输入正确商户号"));
                                } else {
                                    this.getRealNameByPhone(value, (res) => {
                                        if (res.respCode == "0000") {
                                            this.memName = res.contents;
                                            if (!this.memName) {
                                                callback(new Error("查询不到此商户"));
                                                this.memName = "";
                                            } else {
                                                callback();
                                            }
                                        } else {
                                            callback(new Error("查询不到此商户"));
                                            this.memName = "";
                                        }
                                    });
                                }
                            },
                        },
                    ],
                },
                couponId: [
                    {
                        required: true,
                        validator: (rule, value, callback) => {
                            if (!value) {
                                return callback(new Error("请选择"));
                            }
                            const arr = this.dialogModel.couponStr;
                            let index = 0;
                            arr.forEach((item) => {
                                if (item.couponId == value) {
                                    index++;
                                }
                            });
                            if (index > 1) {
                                return callback(new Error("所选优惠券不可重复"));
                            }
                            return callback();
                        },
                    },
                ],
                couponNum: [
                    {
                        required: true,
                        message: "请输入",
                    },
                ],
                page: {},
                isPage: false,
                flag: "",
            };
        },
        inject: ["reload"],
        mixins: [loadMixin, dialogMixin, validatorsMixin],
        mounted() {
            this.load();
            this.getTypeNames("chnName", (res) => {
                this.chnName = [...this.chnName, ...res];
            });
        },
        computed: {
            submitData() {
                this.params = {
                    current: this.isPage ? this.page.currentPage : 1,
                    size: this.page.pageSize,
                };
                return this.params;
            },
            dialogData() {
                let params = {};
                switch (this.flag) {
                    case 1: //修改-添加
                        params = {
                            groupName: this.dialogModel.groupName,
                            valid: this.dialogModel.valid,
                            chnCode: this.dialogModel.chnCode.join(','),
                            couponStr: JSON.stringify(this.dialogModel.couponStr),
                        };
                        if (this.itemId) {
                            params.id = this.itemId;
                        }
                        break;
                    case 2: //发放
                        params = {
                            acctType: this.dialogModel.acctType,
                            merNo: this.dialogModel.merNo,
                            number: this.dialogModel.number,
                            tsId: this.dialogModel.tsId,
                            id: this.itemId,
                            modifierUser: this.userInfo.realName,
                        };
                        break;
                    default:
                        break;
                }
                console.log(params);
                return params;
            },
            dialogService() {
                let service = null;
                switch (this.flag) {
                    case 1: //修改-添加
                        if (this.itemId) {
                            service = TransactionService.coupongroupmanageEdit;
                        } else {
                            service = TransactionService.coupongroupmanageInsert;
                        }
                        break;
                    case 2: //发放
                        service = TransactionService.coupongroupmanagefafang;
                        break;
                    default:
                        break;
                }
                return service;
            },
            ...mapGetters(["serverType", "tatId", "userId", "userInfo"]),
        },
        watch: {
            "dialogModel.merNo"(val, oldval) {
                if (val == "") {
                    this.memName = {};
                }
            },
        },
        methods: {
            load() {
                this.formModel = {};
                this.page = this.$refs.commonTable.page;
                this.getList();
            },
            getPage() {
                this.isPage = true;
                this.getList();
            },
            getList() {
                this.doLoad(
                    this.submitService,
                    this.submitData,
                    (res) => {
                        this.doCheck(res, (res) => {
                            this.onSuccess(res);
                            this.isPage = false;
                        });
                    },
                    "信息获取失败"
                );
            },
            getcouponListall() {
                this.doLoad(
                    TransactionService.couponListall,
                    "",
                    (res) => {
                        this.doCheck(res, (res) => {
                            const result = res.contents;
                            this.couponListall = result;
                        });
                    },
                    "信息获取失败"
                );
            },
            getRealNameByPhone(val, onSuccess) {
                const params = this.dialogModel.acctType == 7 ? {
                    targetUserId: val
                } : {
                    tatSimpleId: this.tatId,
                    merNo: val,
                    // chnCode: this.dialogModel.chnCode,
                };
               const serverUrl = this.dialogModel.acctType == 7 ? TransactionService.GetRealNamePrivate : TransactionService.getRealName
                this.doLoad(
                    serverUrl,
                    params,
                    (res) => {
                        onSuccess && onSuccess(res);
                    }, error => {
                        this.memName = {}
                    }
                );
            },
            getdetail(id) {
                this.doLoad(
                    TransactionService.coupongroupmanageDetail,
                    {
                        id: id,
                    },
                    (res) => {
                        this.doCheck(res, (res) => {
                            const result = res.contents;
                            this.dialogModel = JSON.parse(JSON.stringify(result));
                            this.dialogModel.chnCode = this.dialogModel.chnCode.split(',')
                            this.dialogModel.couponStr = [];
                            if (result.couponDtl) {
                                for (let i = 0; i < result.couponDtl.length; i++) {
                                    this.dialogModel.couponStr.push({
                                        couponId: result.couponDtl[i].couponId,
                                        couponNum: result.couponDtl[i].couponNum,
                                    });
                                }
                            } else {
                                this.dialogModel.couponStr.push({
                                    couponId: "",
                                    couponNum: undefined,
                                });
                            }
                        });
                    },
                    "信息获取失败"
                );
            },
            handleDelete(item) {
                this.showConfirm("是否删除？")
                    .then(() => {
                        this.doDelete(item.id);
                    })
                    .catch(() => {
                    });
            },
            doDelete(id) {
                this.doLoad(
                    TransactionService.coupongroupmanageDel,
                    {
                        id: id,
                    },
                    (res) => {
                        this.doCheck(res, (res) => {
                            this.commonSuccess(res);
                        });
                    },
                    "操作失败"
                );
            },
            openAddDialog(flag, item) {
                this.flag = flag;
                this.itemId = item ? item.id : "";
                if (this.flag == 1) {
                    this.getdetail(this.itemId);
                } else {
                    this.dialogModel.acctType = "7"
                }
                console.log('openAddDialog', this.dialogModel)
                this.$refs.formDialog.open();
                this.getcouponListall();
            },
            AddLevelItem() {
                this.dialogModel.couponStr.push({
                    couponId: "",
                    couponNum: undefined,
                });
            },
            RemoveLevelItem(item) {
                this.showConfirm("确定要删除此行？")
                    .then(() => {
                        let index = this.dialogModel.couponStr.indexOf(item);
                        if (index !== 0) {
                            this.dialogModel.couponStr.splice(index, 1);
                        }
                    })
                    .catch(() => {
                    });
            },
            dialogClose() {
                this.dialogModel = {
                    groupName: "",
                    valid: undefined,
                    chnCode: [],
                    couponStr: [
                        {
                            couponId: "",
                            couponNum: undefined,
                        },
                    ],
                    merNo: "",
                    acctType: "7"
                };
                this.itemId = "";
                this.couponListall = [];
                this.flag = "";
                this.memName = {};
            },
            dialogSuccess(res) {
                this.commonSuccess(res);
                this.$refs.formDialog.closeDialog();
            },
            commonSuccess(res) {
                this.showSuccess(res.respMsg);
                this.getList();
            },
            onSuccess(res) {
                this.doCheck(res, (res) => {
                    const result = res.contents;
                    this.tableData = result.rows;
                    this.page.currentPage = result.current;
                    this.page.total = result.total;
                    this.page.pageSize = result.size;
                });
            },
            formatterTableDataChnCode(row, column, cellValue, index) {
                let value = "--";
                const valueArr = cellValue.split(',');
                if (valueArr.length > 0) {
                    value = [];
                    for (let i = 0; i < valueArr.length; i++) {
                        this.chnName.forEach((item) => {
                            if (item.dictKey == valueArr[i]) {
                                value.push(item.dictValue);
                            }
                        });
                    }
                    return value.join(' , ');
                }

                return value;
            },
        },
    };
</script>

<style scoped>
    .text {
        width: 145px !important;
        margin-left: 12px;
        float: left;
    }

    .mem-name p {
        margin-bottom: 20px;
        vertical-align: middle;
        line-height: 40px;
        color: rgba(170, 170, 170, 1);
    }

    .mem-name p:first-child {
        display: inline-block;
        width: 90px;
        text-align: right;
        vertical-align: middle;
        font-size: 14px;
        color: #606266;
        line-height: 40px;
    }
</style>



// WEBPACK FOOTER //
// src/view/page/AppManager/CouponGroupManage.vue